import React, { useEffect, useState } from 'react';
import { X, BarChart3, Loader2 } from 'lucide-react';
import { staffApi } from '../../services/api';

const fmt = (v, suffix = '') => (v == null ? '—' : `${v}${suffix}`);

export default function ShiftStatsModal({ onClose }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    staffApi.get('/kitchen/today-stats')
      .then(r => setStats(r.data))
      .catch(() => setStats(null))
      .finally(() => setLoading(false));
  }, []);

  const cards = stats ? [
    { label: 'Ordini ricevuti', value: fmt(stats.received), testid: 'stat-received' },
    { label: 'Completati', value: fmt(stats.completed), testid: 'stat-completed' },
    { label: 'Annullati', value: fmt(stats.cancelled), testid: 'stat-cancelled' },
    { label: 'Attivi ora', value: fmt(stats.active), testid: 'stat-active' },
    { label: 'Tempo medio prep.', value: fmt(stats.avg_prep_min, ' min'), testid: 'stat-avgprep' },
    { label: 'Tempo medio evasione', value: fmt(stats.avg_fulfillment_min, ' min'), testid: 'stat-avgful' },
    { label: '"Occupato" attivato', value: fmt(stats.busy_activations, ' volte'), testid: 'stat-busy' },
    { label: 'Incasso completati', value: `${Number(stats.revenue || 0).toFixed(2)}€`, testid: 'stat-revenue' },
  ] : [];

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-end md:items-center justify-center p-0 md:p-4" data-testid="kds-stats-modal">
      <div className="bg-[#18181E] text-white w-full md:max-w-md rounded-t-3xl md:rounded-2xl border border-white/10">
        <div className="flex items-center justify-between p-4 border-b border-white/5">
          <h2 className="font-extrabold text-lg flex items-center gap-2"><BarChart3 size={18} className="text-orange-400" /> Turno di oggi</h2>
          <button onClick={onClose} data-testid="kds-stats-close" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/5"><X size={16} /></button>
        </div>
        <div className="p-4">
          {loading && <div className="flex justify-center py-8"><Loader2 className="animate-spin text-orange-400" /></div>}
          {!loading && !stats && <p className="text-center text-white/40 py-8 text-sm">Statistiche non disponibili</p>}
          {!loading && stats && (
            <div className="grid grid-cols-2 gap-2.5">
              {cards.map(c => (
                <div key={c.testid} data-testid={c.testid} className="bg-[#1C1C22] rounded-xl p-3 border border-white/5">
                  <p className="text-xl font-extrabold">{c.value}</p>
                  <p className="text-[11px] text-white/50 mt-0.5">{c.label}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
